const initialState =
{
    data: [],
    saving: false,
    usuarios:[],
    referencia:0,
};

export default (state = initialState, action) => {
    switch(action.type)
    {
        case 'INVENTARIO_FISICO_LIST':
        console.log('busqueda',action.payload);
             return {
                ...state,
                data: action.payload
            }
        case 'SAVE_SUCCESS':
            return {
                ...state,
                saving: false,
                data: [...state.data, action.payload]
            }
        case 'SAVE':
            return {
                ...state,
                saving: true
            }
        case 'UPDATE_SUCCESS':
            let newp = action.payload;
            return {
                ...state,
                saving: false,
                data: state.data.map((d, i) => { return (d.value == newp.value) ? newp : d })
            }
        case 'REFERENCIA_TABLA':
            return{
                ...state,
                referencia : action.payload
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/cotizacion.js